"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const styles_1 = require("@material-ui/core/styles");
const theme_1 = require("../../styles/theme");
const common_1 = require("../../utils/common");
const HEADER_FOOTER_PADDING = 175;
exports.useStyles = (0, styles_1.makeStyles)((theme) => ({
    formElementWrapper: {
        width: '100%',
        '& .MuiOutlinedInput-root': {
            height: '100%',
            borderRadius: 5,
            padding: 0,
        },
    },
    customBorderColor: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                border: `none`,
                borderRadius: 5,
                padding: 0,
            },
            '&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                border: `none`,
                borderRadius: 5,
                color: theme_1.colors.black35,
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: 0,
            fontSize: 16,
            fontFamily: 'Roboto',
            fontWeight: 400,
            color: theme_1.colors.black0,
            lineHeight: 'normal',
            '&::placeholder': {
                color: theme_1.colors.black35,
                opacity: 1,
                fontSize: 16,
                fontFamily: 'Roboto',
                fontWeight: 400,
                lineHeight: 'normal',
            },
        },
    },
    mediaInput: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 10,
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            flexDirection: 'column',
            gap: 10,
            alignItems: 'flex-start'
        },
    },
    labelWrapper: { marginBottom: '0px !important' },
    selectInput: (props) => ({
        '&.MuiInput-underline:before': {
            border: 'none',
        },
        '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 'none',
        },
        '&.MuiInput-underline': {
            '&:after': {
                border: 'none',
            },
        },
        '&.MuiInputBase-root': {
            border: 'none',
            borderRadius: 5,
            padding: 0,
            background: theme_1.colors.white,
            marginTop: 21,
            cursor: 'pointer',
        },
        '& .MuiInputBase-input': {
            padding: 0,
            cursor: 'pointer',
        },
    }),
    selectIcon: {
        width: '10px',
        height: 5,
        transform: 'rotate(-90deg)',
        fill: `var(--action-active, ${theme_1.colors.black54})`,
    },
    appBar: {
        backgroundColor: `${theme.palette.secondary.main} !important`,
        ' & .MuiToolbar-regular': {
            minHeight: '50px',
        },
    },
    // text colors
    textGreen: {
        color: theme_1.colors.crayola,
    },
    textWhite: {
        color: theme_1.colors.white,
    },
    textBlue: {
        color: theme_1.colors.defaultPrimary,
    },
    textDull: {
        color: theme_1.colors.silver,
    },
    errorText: {
        marginTop: 10,
        color: `${theme_1.colors.dangerFontColor} !important`,
        lineHeight: 'normal',
        fontSize: 12,
        fontWeight: 400,
    },
    warningText: {
        color: theme_1.colors.festival,
    },
    deleteIconBtn: { color: theme_1.colors.dodgerBlue, padding: 0 },
    warningBorderBottom: {
        '&:after': {
            borderBottom: `2px solid ${theme_1.colors.festival}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(1)',
        },
    },
    barCodeRootContainer: {
        padding: '22px 34px',
        height: `calc(100% - ${HEADER_FOOTER_PADDING}px)`,
        overflowY: 'scroll',
        '&::-webkit-scrollbar': {
            width: 7,
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: 5,
            backgroundColor: theme_1.colors.scrollBar,
        },
        [theme.breakpoints.down(common_1.MOBILE_BREAKPOINT)]: {
            padding: 22,
        },
    },
    // font sizes
    fontSizeXSm: {
        fontSize: 13,
    },
    fontSizeSm: {
        fontSize: 14,
    },
    fontSizeNormal: {
        fontSize: 16,
    },
    fontSizeLg: {
        fontSize: 18,
    },
    //margin
    mlSm: {
        // marginLeftSmall
        marginLeft: theme.spacing(1),
    },
    ml: {
        // marginLeftSmall
        marginLeft: theme.spacing(2),
    },
    mlLg: {
        // marginRightSmall
        marginRight: theme.spacing(3),
    },
    mrSm: {
        // marginRightSmall
        marginRight: theme.spacing(1),
    },
    mr: {
        // marginRightSmall
        marginRight: theme.spacing(2),
    },
    mrLg: {
        // marginRightSmall
        marginRight: theme.spacing(3),
    },
    mtSm: {
        // marginTopSmall
        marginTop: theme.spacing(1),
    },
    mt: {
        // marginTopSmall
        marginTop: theme.spacing(2),
    },
    mtLg: {
        // marginTopSmall
        marginTop: theme.spacing(3),
    },
    mbSm: {
        // marginBottomSmall
        marginBottom: theme.spacing(1),
    },
    mb: {
        // marginBottomSmall
        marginBottom: theme.spacing(2),
    },
    mbLg: {
        // marginBottomSmall
        marginBottom: theme.spacing(3),
    },
    centerText: {
        flex: 1,
        textAlign: 'center',
    },
    content: {
        margin: '10px 8px',
    },
    captureLocationBtn: {
        backgroundColor: theme.palette.secondary.main,
        color: theme_1.colors.white,
    },
    captureLocationIcon: {
        color: theme_1.colors.blue2,
    },
    lightLabel: {
        left: 0,
        fontFamily: `'Roboto', sans-serif`,
        fontWeight: 'normal',
        fontSize: '1rem',
        color: theme_1.colors.black54,
        transform: 'translate(0, 1.5px)',
        transformOrigin: 'top left',
        '& .labelWrapper-label': {
            fontSize: '0.75rem',
        },
    },
    value: {
        fontFamily: `'Roboto', sans-serif`,
        fontWeight: 'normal',
        fontSize: 16,
        display: 'flex',
        alignItems: 'flex-end',
        color: theme_1.colors.black87,
    },
    labelShrink: {
        transform: 'translate(0px,0px)',
        '& .labelWrapper-label': {
            fontSize: 14,
            fontWeight: 500,
            color: theme_1.colors.black0,
        },
    },
    imageCountText: {
        color: theme_1.colors.black0,
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '100%',
    },
    endAdormentIcon: { cursor: 'pointer' },
    errorTxt: { marginTop: 10, color: `${theme_1.colors.dangerFontColor} !important`, lineHeight: 'normal', fontSize: 12, fontWeight: 400 },
    uploadfiles: {
        display: 'flex',
        flexDirection: 'column',
    },
    uploadList: {
        color: theme_1.colors.black0,
        fontFamily: 'Roboto',
        fontSize: '15px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '100%',
    },
    innerContainer: {
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        marginTop: 10,
    },
    selectRoot: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    selectBody: {
        width: '100%'
    },
    radioButton: {
        '&.Mui-checked': {
            color: theme.palette.primary.main,
        },
    },
}));
//# sourceMappingURL=CommonWeb.js.map